import { RequiredErrorMessage } from '../constants';

const InputCommonValidators = {
  props: {
    isRequired: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    validateIsRequired(value) {
      return this.getErrorObject(this.isRequired && !value, RequiredErrorMessage);
    },
    getErrorObject(isError, errorMessage) {
      return { isError, errorMessage };
    },
    getRequiredLabel(label) {
      return this.isRequired ? `${label} *` : label;
    },
  },
};

export default InputCommonValidators;
